// import React, { Component } from 'react';
// import { InputText } from 'primereact/inputtext';
// import { InputNumber } from 'primereact/inputnumber';
// import { InputSwitch } from 'primereact/inputswitch';
// import { Dropdown } from 'primereact/dropdown';
// import { Toast } from 'primereact/toast';
// import { connect } from 'react-redux';
// import Messages from '../../../shared/UI/Messages/Messages';
// import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
// import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
// import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
// import * as actions from '../../../store/actions/index';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { Button } from 'primereact/button';
// import  MultiColumnMultiSelect  from '../../../shared/UI/MultiColumnMultiSelect/MultiColumnMultiSelect';

// const unitColumns = [
//     {
//         field: 'label',
//         header: 'Unit Name'
//     },
//     {
//         field: 'value',
//         header: 'Code'
//     }
// ];

// const modifierColumns = [
//     { field: 'value', header: 'ID' },
//     { field: 'label', header: 'Modifier Name' },
// ];

// class AddMenuitem extends Component {
//     state = {
//         type: 'add',
//         menuItemId: null,
//         isActive: true,
//         menuCategoryId: null,
//         menuCode: '',
//         menuName: '',
//         sellingPrice: null,
//         baseunit: null,
//         CompanyId: this.props.loggedUserDetail.CompanyId,
//         createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
//         createdDate: new Date(),
//         touch: false,
//         conversionRows: [
//     { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
// ],
//         selectedcategory: [],
//         selectedModifiers: [],
//     }
    

//     componentDidMount() {
//         this.getAccess = HASACCESS(USER_SUBMENU_ID);
//         let id = this.props.match.params.id;
//         this.props.getMasterKeywordList('unit');
//         this.props.getMasterKeywordList('Menucategory');
//         this.props.getMasterKeywordList('Modifier');
//          this.props.getMasterTableList(  `res/GetInvMenuItembyid?MenuItemId=${id} &`,this.props.loggedUserDetail.CompanyId );
//         let type = this.props.match.params.type;
//         if (type !== 'add') {
//             this.timer();
//         }
//     }

//     timer = () => {
//         this.intervalID = setInterval(() => {
//             this.fetchSingleProcess();
//         }, 2000);
//     }

//     componentWillUnmount() {
//         if (this.props.tableLists.usersList !== undefined) {
//             clearInterval(this.intervalID);
//         }
//     }

//     fetchSingleProcess = () => {
//         let type = this.props.match.params.type;
//         let storageItems = [];
//         if (this.props.tableLists.usersList !== undefined) {
//             storageItems = this.props.tableLists.users;
//             clearInterval(this.intervalID);
//         }
//         if (storageItems) {
//             let filterData = storageItems;
//             if (filterData) {
//                   const modifierList = this.props.modifierList || [];
//                 const savedIds = filterData.allowedmodifier
//                     ? filterData.allowedmodifier.split(',').map(s => s.trim()).filter(Boolean)
//                     : [];
//                 const selectedModifiers = modifierList.filter(m =>
//                     savedIds.includes(String(m.value))
//                 );
//                 this.setState({
//                     type: type,
//                     menuItemId: filterData.menuItemId,
//                     isActive: filterData.isActive,
//                     menuCategoryId: filterData.menuCategoryId,
//                     menuCode: filterData.menuCode,
//                     menuName: filterData.menuName,
//                     sellingPrice: filterData.sellingPrice,
//                     baseunit: filterData.baseunit,
//                     selectedModifiers,
//                     // only if the API returns conversion rows
//                     conversionRows: (filterData.conversionRows && filterData.conversionRows.length > 0)
//                         ? filterData.conversionRows.map(r => ({ ...r, id: Date.now() + Math.random() }))
//                         : [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
//                 });
//             }
//         }
//     }

//     change = (e) => {
//         let { name, value } = e.target;
//         this.setState({ [name]: value, touch: true });
//     }

//     add = () => {

//          const allowedmodifier = this.state.selectedModifiers
//             .map(m => m.value)
//             .join(',');

//         var data = {
//             companyId: this.state.CompanyId,
//             isActive: this.state.isActive,
//             menuCategoryId: this.state.menuCategoryId,
//             menuCode: this.state.menuCode,
//             menuName: this.state.menuName,
//             sellingPrice: this.state.sellingPrice,
//             baseunit: this.state.baseunit,
//             createdBy: this.state.createdBy,
//             createdDate: this.state.createdDate,
//              allowedmodifier,
//             conversionRows: this.state.conversionRows.map(({ fromUnit, toUnit, conversionFactor }) => ({
//                 fromUnit,
//                 toUnit,
//                 conversionFactor
//                 })),
//         };

//         if (this.state.type === 'edit') {
//             data.menuItemId = this.state.menuItemId;
//         }

//         this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
//     }

//     resetData = () => {
//         this.setState({
//             menuItemId: null,
//             isActive: false,
//             menuCategoryId: null,
//             menuCode: '',
//             menuName: '',
//             sellingPrice: null,
//             baseunit: null,
//             type: 'add',
//             touch: false,
//             selectedModifiers: [],
//             conversionRows: [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }]
//         });
//     }
//     addConversionRow = () => {
//     this.setState(prev => ({
//         conversionRows: [
//             ...prev.conversionRows,
//             { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
//         ],
//         touch: true
//     }));
// }

// deleteConversionRow = (rowId) => {
//     this.setState(prev => ({
//         conversionRows: prev.conversionRows.filter(r => r.id !== rowId),
//         touch: true
//     }));
// }

// updateConversionRow = (rowId, field, value) => {
//     this.setState(prev => ({
//         conversionRows: prev.conversionRows.map(r =>
//             r.id === rowId ? { ...r, [field]: value } : r
//         ),
//         touch: true
//     }));
// }

// fromUnitBody = (row) => (
//     <Dropdown
//         options={this.props.unitList || []}
//         value={row.fromUnit}
//         onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
//         placeholder="Select Unit"
//         {...DROPDOWN_CONFIG}
//     />
// )

// toUnitBody = (row) => (
//     <Dropdown
//         options={this.props.unitList || []}
//         value={row.toUnit}
//         onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
//         placeholder="Select Unit"
//         {...DROPDOWN_CONFIG}
//     />
// )

// conversionFactorBody = (row) => (
//     <InputNumber
//         value={row.conversionFactor}
//         onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
//         placeholder="Factor"
//         mode="decimal"
//         minFractionDigits={4}
//     />
// )

// deleteBody = (row) => (
//     <Button
//         icon="pi pi-trash"
//         className="p-button-danger p-button-text"
//         onClick={() => this.deleteConversionRow(row.id)}
//     />
// )

//     render() {
//         if (this.props.success) {
//             REDIRECT_TO_URL('/menuitem/', this.props);
//         }

//         let addAccess = true;
//         let editAccess = true;
//         if (this.getAccess !== undefined) {
//             if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
//                 this.props.history.push('/dashboard');
//             }
//             addAccess = this.getAccess.addAccess === true;
//             editAccess = this.getAccess.editAccess === true;
//         }
//         let accessButton = { addAccess: addAccess, editAccess: editAccess };

//         let isEnabled = this.state.touch === true;

//         let redirectURL = '/menuitem/';
//         if (this.props.userDetail && this.props.match.params.id !== undefined) {
//             if (this.props.userDetail.userId === this.props.match.params.id) {
//                 redirectURL = '/dashboard';
//             }
//         }

//         return (
//             <div className="p-grid">
//                 {this.props.loading && <div className="page-loader"></div>}
//                 {this.props.error !== null && <Messages type="error" message={this.props.error} />}
//                 {this.props.success !== null && <Messages type="success" message={this.props.success} />}
//                 <Toast ref={(el) => this.growl = el} />
//                 <div className="p-col-12">
//                     <div className="card card-w-title" style={{ position: 'relative' }}>
//                         <h1>{this.state.type} Item</h1>

//                         <div className="p-grid mt1">
//                             <div className="p-col-12">
//                                 <div className="card card-w-title">
//                                     <div className="p-grid">
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="menuCategoryId">Menu Category <span className="requiredColor">*</span></label>
//                                             <div className="mt1">

//                                         <MultiColumnMultiSelect
//                                         multiple={false}
//                                         value={this.state.selectedcategory}
//                                         options={this.props.CategoryList || []}
//                                         optionValue="value"
//                                         optionLabel="label"
//                                         columns={[
//                                             {
//                                                 field: 'id',
//                                                 header: 'ID'
//                                             },
//                                             {
//                                                 field: 'label',
//                                                 header: 'Unit Name'
//                                             },
//                                         ]}
//                                         placeholder="Select Category"
//                                         onChange={(selectedcategory) =>
//                                             this.setState({
//                                                 selectedcategory,
//                                                 touch: true
//                                             })
//                                         }
//                                         />
//                                         </div>
//                                         </div>

//                                         {/* isActive - Switch */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="isActive">Is Active</label>
//                                             <div className="mt1">
//                                                 <InputSwitch
//                                                     id="isActive"
//                                                     name="isActive"
//                                                     checked={this.state.isActive}
//                                                     onChange={(e) => this.setState({ isActive: e.value, touch: true })}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* menuCategoryId - Dropdown */}
//                                         {/* <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="menuCategoryId">Menu Category <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <Dropdown
//                                                     className="p-col-12"
//                                                     id="menuCategoryId"
//                                                     name="menuCategoryId"
//                                                     options={this.props.CategoryList || []}
//                                                     value={this.state.menuCategoryId}
//                                                     onChange={(e) => this.setState({ menuCategoryId: e.value, touch: true })}
//                                                     placeholder="Select Menu Category"
//                                                     {...DROPDOWN_CONFIG}
//                                                 />
//                                             </div>
//                                         </div> */}

//                                         {/* menuCode - InputText */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="menuCode">Menu Code <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputText
//                                                     className="p-col-12"
//                                                     id="menuCode"
//                                                     name="menuCode"
//                                                     value={this.state.menuCode}
//                                                     onChange={this.change}
//                                                     placeholder="Menu Code"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* menuName - InputText */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="menuName">Menu Name <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputText
//                                                     className="p-col-12"
//                                                     id="menuName"
//                                                     name="menuName"
//                                                     value={this.state.menuName}
//                                                     onChange={this.change}
//                                                     placeholder="Menu Name"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* sellingPrice - InputNumber */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="labeltop" htmlFor="sellingPrice">Selling Price <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <InputNumber
//                                                     // className="p-col-12"
//                                                     id="sellingPrice"
//                                                     name="sellingPrice"
//                                                     value={this.state.sellingPrice}
//                                                     onValueChange={(e) => this.setState({ sellingPrice: e.value, touch: true })}
//                                                     placeholder="Selling Price"
//                                                     mode="decimal"
//                                                     minFractionDigits={2}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* baseunit - Dropdown */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="baseunit">Base Unit <span className="requiredColor">*</span></label>
//                                             <div className="mt1">
//                                                 <Dropdown
//                                                     className="p-col-12"
//                                                     id="baseunit"
//                                                     name="baseunit"
//                                                     options={this.props.unitList || []}
//                                                     value={this.state.baseunit}
//                                                     onChange={(e) => this.setState({ baseunit: e.value, touch: true })}
//                                                     placeholder="Select Base Unit"
//                                                     {...DROPDOWN_CONFIG}
//                                                 />
//                                             </div>
//                                         </div>
                                        
//                                         {/* ── Allowed Modifiers ─────────────────────────────── */}
//                                         <div className="p-col-12 p-md-6 p-lg-4">
//                                             <label className="label" htmlFor="allowedmodifier">
//                                                 Allowed Modifiers
//                                             </label>
//                                             <div className="mt1">
//                                                 <MultiColumnMultiSelect
//                                                     multiple={true}
//                                                     value={this.state.selectedModifiers}
//                                                     options={this.props.modifierList || []}
//                                                     optionValue="value"
//                                                     optionLabel="label"
//                                                     columns={modifierColumns}
//                                                     placeholder="Select Modifiers"
//                                                     onChange={(selectedModifiers) =>
//                                                         this.setState({ selectedModifiers, touch: true })
//                                                     }
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Unit Conversion Table */}
//                                    <div className="p-col-12">
//                                     <div className="card card-w-title">
//                                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                             <h1>Unit Conversion</h1>
//                                             <Button label="Add Row" icon="pi pi-plus" className="p-button-sm" onClick={this.addConversionRow} />
//                                         </div>

//                                         <DataTable value={this.state.conversionRows}>

//                                             <Column
//                                                 header="Conversion"
//                                                 body={(row) => (
//                                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

//                                                         {/* 1 */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>1</span>

//                                                         {/* From Unit */}
//                                                         <Dropdown
//                                                             options={this.props.unitList || []}
//                                                             value={row.fromUnit}
//                                                             onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
//                                                             placeholder="From Unit"
//                                                             style={{ width: '160px' }}
//                                                             {...DROPDOWN_CONFIG}
//                                                         />

//                                                         {/* = */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>=</span>

//                                                         {/* Conversion Factor */}
//                                                         <InputNumber
//                                                             value={row.conversionFactor}
//                                                             onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
//                                                             placeholder="Factor"
//                                                             // mode="number"
//                                                             // minFractionDigits={4}
//                                                             inputStyle={{ width: '130px' }}
//                                                         />

//                                                         {/* x */}
//                                                         <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>x</span>

//                                                         {/* To Unit */}
//                                                         <Dropdown
//                                                             options={this.props.unitList || []}
//                                                             value={row.toUnit}
//                                                             onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
//                                                             placeholder="To Unit"
//                                                             style={{ width: '160px' }}
//                                                             {...DROPDOWN_CONFIG}
//                                                         />

//                                                     </div>
//                                                 )}
//                                             />

//                                             <Column
//                                                 header="Action"
//                                                 style={{ width: '70px', textAlign: 'center' }}
//                                                 body={(row) => (
//                                                     <Button
//                                                         icon="pi pi-trash"
//                                                         className="p-button-danger p-button-text"
//                                                         onClick={() => this.deleteConversionRow(row.id)}
//                                                     />
//                                                 )}
//                                             />

//                                         </DataTable>
//                                     </div>
//                                 </div>
//                                         <div className="p-col-12 p-lg-12">

//                                 <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                            
//                             </div>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// const mapStateToProps = state => {
//     return {
//         loggedUserDetail: state.auth.userObject,
//         userDetail: state.auth.userDetail,
//         loading: state.master.loading,
//         error: state.master.error,
//         success: state.master.success,
//         tableLists: state.master.tableLists,
//         unitList: state.keyword.unit,
//         CategoryList: state.keyword.Menucategory,
//         modifierList: state.keyword.modifier,  
//     };
// };

// const mapDispatchToProps = dispatch => {
//     return {
//         getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
//         getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
//         processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
//     };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(AddMenuitem);

import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Messages from '../../../shared/UI/Messages/Messages';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import MultiColumnMultiSelect from '../../../shared/UI/MultiColumnMultiSelect/MultiColumnMultiSelect';

const modifierColumns = [
    { field: 'value', header: 'ID' },
    { field: 'label', header: 'Modifier Name' },
];

class AddMenuitem extends Component {
    state = {
        type: 'add',
        menuItemId: null,
        isActive: true,
        menuCategoryId: null,
        menuCode: '',
        menuName: '',
        sellingPrice: null,
        baseunit: null,
        defaultkitchen: null,
        defaultstore: null,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
        createdDate: new Date(),
        touch: false,
        conversionRows: [
            { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
        ],
        componentRows: [
            { id: Date.now(), menuComponent: null, portion: null, unit: null }
        ],
        selectedcategory: [],
        // selectedModifiers holds the array that MultiColumnMultiSelect
        // gives back; we derive the comma-separated string at save time.
        selectedModifiers: [],
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterKeywordList('uom');
        this.props.getMasterKeywordList('Menucategory');
        this.props.getMasterKeywordList('modifier');   // ← fetch modifier master
        this.props.getMasterKeywordList('Kitchen');
        this.props.getMasterKeywordList('StorageLocation');
        this.props.getMasterKeywordList('MenuComponent');
        let type = this.props.match.params.type;
        if (type !== 'add') {
            this.fetchSingleProcess(id);
        }
    }

    fetchSingleProcess = (id) => {
        this.props.getMasterTableList(
            `res/GetInvMenuItembyid?MenuItemId=${id}`,
            this.state.CompanyId
        );
    }

    componentDidUpdate(prevProps) {
        const type = this.props.match.params.type;
        if (type === 'add') return;

        const filterData    = this.props.tableLists?.invMenuItem;
        const prevFilterData = prevProps.tableLists?.invMenuItem;

        const categoryList = this.props.CategoryList || [];
        const prevCategoryList = prevProps.CategoryList || [];

        // Only map into state once when the API response arrives/changes
        if (filterData && filterData !== prevFilterData) {
            const conversionList = this.props.tableLists?.resmenuitemuomconversionlist || [];

            const componentList = this.props.tableLists?.resmenucomponentlist || [];

            const modifierList = this.props.modifierList || [];
            const savedIds = filterData.allowedModifier
                ? filterData.allowedModifier.split(',').map(s => s.trim()).filter(Boolean)
                : [];
            const selectedModifiers = modifierList.filter(m =>
                savedIds.includes(String(m.value))
            );

            // MultiColumnMultiSelect (single-select mode) needs the whole
            // matching option object, not the raw id — see its displayText().
            const selectedcategory = categoryList.find(c => c.value === filterData.menuCategoryId) || null;

            this.setState({
                type,
                menuItemId:     filterData.menuItemId,
                isActive:       filterData.isActive,
                menuCategoryId: filterData.menuCategoryId,
                menuCode:       filterData.menuCode,
                menuName:       filterData.menuName,
                sellingPrice:   filterData.sellingPrice,
                baseunit:       filterData.baseunit,
                defaultkitchen: filterData.defaultkitchen,
                defaultstore:   filterData.defaultstore,
                selectedModifiers,
                selectedcategory,
                conversionRows: conversionList.length > 0
                    ? conversionList.map(r => ({ ...r, id: Date.now() + Math.random() }))
                    : [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
                componentRows: componentList.length > 0
                    ? componentList.map(r => ({
                        menuComponent: r.menuComponent,
                        portion: r.portion,
                        unit: r.unit,
                        id: Date.now() + Math.random(),
                    }))
                    : [{ id: Date.now(), menuComponent: null, portion: null, unit: null }],
            });
            return;
        }

        // CategoryList can arrive after filterData (GetMasterKeywordList and
        // GetInvMenuItembyid race independently) — re-derive once it shows up
        // so the field doesn't stay stuck blank when that happens.
        if (filterData && categoryList !== prevCategoryList && categoryList.length > 0 && !this.state.selectedcategory) {
            const selectedcategory = categoryList.find(c => c.value === filterData.menuCategoryId) || null;
            if (selectedcategory) this.setState({ selectedcategory });
        }
    }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // add = () => {
    //     // Convert selectedModifiers array → comma-separated ID string
    //     const allowedModifier = this.state.selectedModifiers
    //         .map(m => m.value)
    //         .join(',');

    //     var data = {
    //         companyId: this.state.CompanyId,
    //         isActive: this.state.isActive,
    //         menuCategoryId: this.state.menuCategoryId,
    //         menuCode: this.state.menuCode,
    //         menuName: this.state.menuName,
    //         sellingPrice: this.state.sellingPrice,
    //         baseunit: this.state.baseunit,
    //         allowedModifier,             // ← "id1,id2,id3"
    //         createdBy: this.state.createdBy,
    //         createdDate: this.state.createdDate,
    //         conversionRows: this.state.conversionRows.map(
    //             ({ fromUnit, toUnit, conversionFactor }) => ({
    //                 fromUnit, toUnit, conversionFactor
    //             })
    //         ),
    //     };

    //     if (this.state.type === 'edit') {
    //         data.menuItemId = this.state.menuItemId;
    //     }

    //     this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
    // }
    
    add = () => {
    // Convert selectedModifiers array → comma-separated ID string (or null if empty)
    const allowedModifier = this.state.selectedModifiers.length
        ? this.state.selectedModifiers.map(m => m.value).join(',')
        : null;

    const invMenuItem = {
        companyid: this.state.CompanyId,
        isActive: this.state.isActive,
        menuCategoryId: this.state.menuCategoryId,
        menuCode: this.state.menuCode,
        menuName: this.state.menuName,
        sellingPrice: this.state.sellingPrice,
        baseunit: this.state.baseunit,
        allowedModifier,
        defaultkitchen: this.state.defaultkitchen,
        defaultstore: this.state.defaultstore,
        photopath: this.state.photopath,
    };

    if (this.state.type === 'edit') {
        invMenuItem.menuItemId = this.state.menuItemId;
        invMenuItem.photopath = `${this.state.menuItemId}.png`;
    }

    const data = {
        invMenuItem,
        resmenuitemuomconversionlist: this.state.conversionRows.map(
            ({ fromUnit, toUnit, conversionFactor }) => ({
                fromUnit,
                toUnit,
                conversionFactor,
            })
        ),
        resmenucomponentlist: this.state.componentRows
            .filter(r => r.menuComponent !== null || r.portion !== null || r.unit !== null)
            .map(({ menuComponent, portion, unit }) => ({
                menuComponent,
                portion,
                unit,
            })),
    };

    this.props.processDynamicData('invMenuItem', this.state.type, data, 'res/GetinvMenuItemList');
}

    resetData = () => {
        this.setState({
            menuItemId: null,
            isActive: false,
            menuCategoryId: null,
            menuCode: '',
            menuName: '',
            sellingPrice: null,
            baseunit: null,
            defaultkitchen: null,
            defaultstore: null,
            type: 'add',
            touch: false,
            selectedModifiers: [],
            conversionRows: [{ id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }],
            componentRows: [{ id: Date.now(), menuComponent: null, portion: null, unit: null }]
        });
    }

    addConversionRow = () => {
        this.setState(prev => ({
            conversionRows: [
                ...prev.conversionRows,
                { id: Date.now(), fromUnit: null, toUnit: null, conversionFactor: null }
            ],
            touch: true
        }));
    }

    deleteConversionRow = (rowId) => {
        this.setState(prev => ({
            conversionRows: prev.conversionRows.filter(r => r.id !== rowId),
            touch: true
        }));
    }

    updateConversionRow = (rowId, field, value) => {
        this.setState(prev => ({
            conversionRows: prev.conversionRows.map(r =>
                r.id === rowId ? { ...r, [field]: value } : r
            ),
            touch: true
        }));
    }

    addComponentRow = () => {
        this.setState(prev => ({
            componentRows: [
                ...prev.componentRows,
                { id: Date.now(), menuComponent: null, portion: null, unit: null }
            ],
            touch: true
        }));
    }

    deleteComponentRow = (rowId) => {
        this.setState(prev => ({
            componentRows: prev.componentRows.filter(r => r.id !== rowId),
            touch: true
        }));
    }

    updateComponentRow = (rowId, field, value) => {
        this.setState(prev => ({
            componentRows: prev.componentRows.map(r =>
                r.id === rowId ? { ...r, [field]: value } : r
            ),
            touch: true
        }));
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/menuitem/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (
                this.getAccess.viewAccess === false &&
                this.props.userDetail.userId !== this.props.match.params.id
            ) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess, editAccess };
        let isEnabled = this.state.touch === true;

        let redirectURL = '/menuitem/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = '/dashboard';
            }
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Item</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title">
                                    <div className="p-grid">

                                        {/* Menu Category */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="menuCategoryId">
                                                Menu Category <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="menuCategoryId"
                                                    name="menuCategoryId"
                                                    options={this.props.CategoryList || []}
                                                    value={this.state.menuCategoryId}
                                                    // Bound to menuCategoryId, which is what add() saves.
                                                    // The previous control only set selectedcategory, so a
                                                    // category picked here never reached the payload.
                                                    onChange={(e) => this.setState({
                                                        menuCategoryId: e.value,
                                                        selectedcategory: (this.props.CategoryList || [])
                                                            .find(c => c.value === e.value) || null,
                                                        touch: true,
                                                    })}
                                                    placeholder="Select Category"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* Is Active */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="isActive">Is Active</label>
                                            <div className="mt1">
                                                <InputSwitch
                                                    id="isActive"
                                                    name="isActive"
                                                    checked={this.state.isActive}
                                                    onChange={(e) => this.setState({ isActive: e.value, touch: true })}
                                                />
                                            </div>
                                        </div>

                                        {/* Menu Code */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="menuCode">
                                                Menu Code <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="menuCode"
                                                    name="menuCode"
                                                    value={this.state.menuCode}
                                                    onChange={this.change}
                                                    placeholder="Menu Code"
                                                />
                                            </div>
                                        </div>

                                        {/* Menu Name */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="menuName">
                                                Menu Name <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="menuName"
                                                    name="menuName"
                                                    value={this.state.menuName}
                                                    onChange={this.change}
                                                    placeholder="Menu Name"
                                                />
                                            </div>
                                        </div>

                                        {/* Selling Price */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="sellingPrice">
                                                Selling Price <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <InputNumber
                                                    id="sellingPrice"
                                                    name="sellingPrice"
                                                    value={this.state.sellingPrice}
                                                    onValueChange={(e) =>
                                                        this.setState({ sellingPrice: e.value, touch: true })
                                                    }
                                                    placeholder="Selling Price"
                                                    mode="decimal"
                                                    minFractionDigits={2}
                                                />
                                            </div>
                                        </div>

                                        {/* Base Unit */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="baseunit">
                                                Base Unit <span className="requiredColor">*</span>
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="baseunit"
                                                    name="baseunit"
                                                    options={this.props.unitList || []}
                                                    value={this.state.baseunit}
                                                    onChange={(e) =>
                                                        this.setState({ baseunit: e.value, touch: true })
                                                    }
                                                    placeholder="Select Base Unit"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* Default Kitchen */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="defaultkitchen">
                                                Default Kitchen
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="defaultkitchen"
                                                    name="defaultkitchen"
                                                    options={this.props.KitchenList || []}
                                                    value={this.state.defaultkitchen}
                                                    onChange={(e) =>
                                                        this.setState({ defaultkitchen: e.value, touch: true })
                                                    }
                                                    placeholder="Select Default Kitchen"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="defaultstore">
                                                Default Store
                                            </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="defaultstore"
                                                    name="defaultstore"
                                                    options={this.props.StoreList || []}
                                                    value={this.state.defaultstore}
                                                    onChange={(e) =>
                                                        this.setState({ defaultstore: e.value, touch: true })
                                                    }
                                                    placeholder="Select Default Store"
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* ── Allowed Modifiers ─────────────────────────────── */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="allowedModifier">
                                                Allowed Modifiers
                                            </label>
                                            <div className="mt1">
                                                <MultiColumnMultiSelect
                                                    multiple={true}
                                                    value={this.state.selectedModifiers}
                                                    options={this.props.modifierList || []}
                                                    optionValue="value"
                                                    optionLabel="label"
                                                    columns={modifierColumns}
                                                    placeholder="Select Modifiers"
                                                    onChange={(selectedModifiers) =>
                                                        this.setState({ selectedModifiers, touch: true })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Unit Conversion Table */}
                                        <div className="p-col-12">
                                            <div className="card card-w-title">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h1>Unit Conversion</h1>
                                                    <Button
                                                        label="Add Row"
                                                        icon="pi pi-plus"
                                                        className="p-button-sm"
                                                        onClick={this.addConversionRow}
                                                    />
                                                </div>

                                                <DataTable value={this.state.conversionRows}>
                                                    <Column
                                                        header="Conversion"
                                                        body={(row) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>1</span>
                                                                <Dropdown
                                                                    options={this.props.unitList || []}
                                                                    value={row.fromUnit}
                                                                    onChange={(e) => this.updateConversionRow(row.id, 'fromUnit', e.value)}
                                                                    placeholder="From Unit"
                                                                    style={{ width: '160px' }}
                                                                    {...DROPDOWN_CONFIG}
                                                                />
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>=</span>
                                                                <InputNumber
                                                                    value={row.conversionFactor}
                                                                    onValueChange={(e) => this.updateConversionRow(row.id, 'conversionFactor', e.value)}
                                                                    placeholder="Factor"
                                                                    inputStyle={{ width: '130px' }}
                                                                />
                                                                <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>x</span>
                                                                <Dropdown
                                                                    options={this.props.unitList || []}
                                                                    value={row.toUnit}
                                                                    onChange={(e) => this.updateConversionRow(row.id, 'toUnit', e.value)}
                                                                    placeholder="To Unit"
                                                                    style={{ width: '160px' }}
                                                                    {...DROPDOWN_CONFIG}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    <Column
                                                        header="Action"
                                                        style={{ width: '70px', textAlign: 'center' }}
                                                        body={(row) => (
                                                            <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-danger p-button-text"
                                                                onClick={() => this.deleteConversionRow(row.id)}
                                                            />
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>

                                        {/* Menu Component Table */}
                                        <div className="p-col-12">
                                            <div className="card card-w-title">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <h1>Menu Component</h1>
                                                    <Button
                                                        label="Add Row"
                                                        icon="pi pi-plus"
                                                        className="p-button-sm"
                                                        onClick={this.addComponentRow}
                                                    />
                                                </div>

                                                <DataTable value={this.state.componentRows}>
                                                    <Column
                                                        header="Menu Component"
                                                        body={(row) => (
                                                            <Dropdown
                                                                options={this.props.MenuComponentList || []}
                                                                value={row.menuComponent}
                                                                onChange={(e) => this.updateComponentRow(row.id, 'menuComponent', e.value)}
                                                                placeholder="Select Menu Component"
                                                                style={{ width: '100%' }}
                                                                {...DROPDOWN_CONFIG}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Portion"
                                                        body={(row) => (
                                                            <InputNumber
                                                                value={row.portion}
                                                                onValueChange={(e) => this.updateComponentRow(row.id, 'portion', e.value)}
                                                                placeholder="Portion"
                                                                mode="decimal"
                                                                minFractionDigits={0}
                                                                maxFractionDigits={4}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Unit"
                                                        body={(row) => (
                                                            <Dropdown
                                                                options={this.props.unitList || []}
                                                                value={row.unit}
                                                                onChange={(e) => this.updateComponentRow(row.id, 'unit', e.value)}
                                                                placeholder="Select Unit"
                                                                style={{ width: '100%' }}
                                                                {...DROPDOWN_CONFIG}
                                                            />
                                                        )}
                                                    />
                                                    <Column
                                                        header="Action"
                                                        style={{ width: '70px', textAlign: 'center' }}
                                                        body={(row) => (
                                                            <Button
                                                                icon="pi pi-trash"
                                                                className="p-button-danger p-button-text"
                                                                onClick={() => this.deleteComponentRow(row.id)}
                                                            />
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-lg-12">
                                            <FooterButton
                                                access={accessButton}
                                                disabled={!isEnabled}
                                                type={this.state.type.toLowerCase()}
                                                save={this.add}
                                                reset={this.resetData}
                                                to={redirectURL}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        unitList: state.keyword.uom,
        CategoryList: state.keyword.Menucategory,
        modifierList: state.keyword.modifier,   // ← modifier master from Redux
        KitchenList: state.keyword.Kitchen,
        StoreList: state.keyword.StorageLocation,
        MenuComponentList: state.keyword.MenuComponent !== undefined ? state.keyword.MenuComponent : [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuitem);